import { render, staticRenderFns } from "./PurchasesInvoicesTable.vue?vue&type=template&id=1cd2b341"
import script from "./PurchasesInvoicesTable.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasesInvoicesTable.vue?vue&type=style&index=0&id=1cd2b341&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports